import { lockScreenScroll } from '../utils/treatment';
import { hideFixedForm, hideFixedFilter, hideFavoriteForm } from './actionsForm';

const sidebarFixed = document.querySelector('.js-sidebar-container');
const formMain = document.querySelector('.form-main');
const filterHeader = document.querySelector('.header-filter');
const favoriteHeader = document.querySelector('.header-favorite');
const unitsSelect = document.querySelector('.units-select');

// FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
export function sidebarFixedBehavior(menu) {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((menu) => {

    menu.addEventListener('click', () => {
      let favoriteText = menu.querySelector('.countFavoriteNumber')


      if(filterHeader && filterHeader.classList.contains('filter-header-fixed')) {
        hideFixedFilter();
        lockScreenScroll();
      }

      if(favoriteHeader && favoriteHeader.classList.contains('favorite-header-fixed')) {
        hideFixedFavorite();
        lockScreenScroll();
      }

      if(formMain && formMain.classList.contains('form-content-fixed')) {
        hideFixedForm();
        lockScreenScroll();
      }

      if(unitsSelect && menu.classList.contains('fixed')) {
        sidebarFixed.classList.toggle('fixed');
        lockScreenScroll();
      }

      sidebarFixed.classList.toggle('d-flex');
      lockScreenScroll();
    });
  });
}

// FUNCTION TO HIDE SIDEBAR FIXED, IF ANOTHER TARGET IS ACTIVE IN DESKTOP
export function hideSidebarFixed(menu) {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((menu) => {
    let menuIcon = menu.querySelector('i');
    let menuText = menu.querySelector('span')
  });

  sidebarFixed.classList.toggle('d-flex');
  lockScreenScroll();
}
